import React from "react";
import Grid from "@mui/material/Grid";

export const CenterOnPage = ({ children }) => (
  <Grid
    container
    spacing={0}
    direction="column"
    alignItems="center"
    justifyContent="center"
    sx={{ minHeight: "100vh" }}
  >
    <Grid size={{ xs: 12 }} display="flex" alignItems="center" justifyContent="center">
      {children}
    </Grid>
  </Grid>
);
